import * as React from "react";
import ReactSelect from 'react-select';

import useTranslation from "../../hooks/useTranslation";

import './Select.scss';

function Select({ className, required, value, options, label, name, onChange, disabled = false, isClearable, emptyOption }) {
    const { t } = useTranslation();

    let builtClassName = "FormSelect FormInput dropdown col-50";
    className && (builtClassName = `${builtClassName} ${className}`);
    disabled && (builtClassName += " disabled");
    required && (builtClassName += " required");

    // podpora "prázdné" možnosti (pokud ji chceš mít v nabídce)
    const opts = emptyOption
        ? [{ value: null, label: "— žádný —" }, ...options]
        : options;

    // DŮLEŽITÉ: undefined -> null
    const selectedOption = opts.find(item => item.value === value) ?? null;

    const handleChange = (selected) => {
        // selected může být null (po vyčištění)
        onChange?.(name, selected ? selected.value : null);
    };

    return (
        <div className={builtClassName}>
            {label !== false && <label>{label || t(name)}</label>}
            <ReactSelect
                required={required}
                className={builtClassName}
                value={selectedOption}
                onChange={handleChange}
                options={opts}
                placeholder="Vyberte..."
                isDisabled={disabled}
                isClearable={isClearable ?? true}
            />
        </div>
    );
}

export default Select;